import axios from 'axios';
import constant from './constant';
import constantV1 from './constantV1';

export async function getApi(url, header) {
  //  console.log("GetApi: ", `${constant.BASE_URL}/${url}`)
  // console.log("TOKEN::", header.accesstoken)
  return await axios.get(`${constant.BASE_URL}/${url}`, {
    headers: {
      Accept: header.Accept,
      'Content-type': header.contenttype,
      'x-access-token':'Bearer ' + header.accesstoken,
      // 'x-access-token': header.accesstoken,
    },
  });
}

export async function getApiWithParam(url, param, header) {
  // console.log("BASE_URL::", constant.BASE_URL);
  // console.log("getApiWithParam: ", `${constant.BASE_URL}/${url}`)
// console.log("PostApi: ", `${constant.BASE_URL}/${url}`)
  return await axios({
    method: 'GET',
    baseURL: constant.BASE_URL,
    url: url,
    params: param,
    headers: {
      Accept: header.Accept,
      'Content-type': header.contenttype,
    },
  });
}

export async function postApi(url, payload, header) {
  return await axios.post(`${constant.BASE_URL}/${url}`, payload, {
    headers: {
      Accept: header.Accept,
      'Content-Type': header.contenttype,
      'x-access-token': 'Bearer ' + header.accesstoken,
    },
  });
}

export async function postApiV2(url, payload, header) {
  console.log("head:",url,header)
  return await axios.post(`${constantV1.BASE_URL}/${url}`, payload, {
    headers: {
      Accept: header.Accept || "application/json",
      "Content-Type": header["Content-Type"] || "application/json",
      'Authorization': 'Bearer ' + header.token,
    },
  });
}


export async function putApi(url, payload, header) {
  return await axios.put(`${constant.BASE_URL}/${url}`, payload, {
    headers: {
      Accept: header.Accept,
      'Content-Type': header.contenttype,
      'x-access-token': header.accesstoken,
    },
  });
}

export async function deleteApi(url, payload, header) {
  // console.log("DeleteApi: ", `${constant.BASE_URL}/${url}`);
  // console.log('DeleteApi: ', url);

  return await axios.delete(`${constant.BASE_URL}/${url}`, {
    headers: {
      Accept: header.Accept,
      'Content-type': header.contenttype,
      'x-access-token': header.accesstoken,
    },
    data: payload,
  });
}